module.exports = __webpack_public_path__ + "2f5d8761b76cb4ab071d2abba013a1a3.MP3";